import { Container } from '@adobe/aem-react-editable-components';

import { AemContainerConfig } from '../Navigation.types';
import { NavigationUtilityLink as NavigationUtilityLinkReact } from './NavigationUtilityLink';
import { NavigationUtilityLinkWrapperProps } from './NavigationUtilityLink.types';
import { FEATURE_FLAGS } from '@marriott/mi-feature-flag-utils';
import clsx from 'clsx';

export const NavigationUtilityLinkWrapper = (props: NavigationUtilityLinkWrapperProps) => {
  const cqPath = `${props.cqPath}/utilityNavigation`;
  const { logoType = '', logoUrl = '', logoImageAltText = '', featureFlagLegacyNav } = props;
  const isLegacyNavFlagEnabled = featureFlagLegacyNav?.[FEATURE_FLAGS.EXPERIENCE_MCOM_LEGACY_NAV];
  const UtilityConfig: AemContainerConfig = {
    emptyLabel: 'Utility Links',
    isEmpty: () => false,
    resourceType: isLegacyNavFlagEnabled
      ? 'mi-aem-homepage-spa/components/content/utilityNavigation'
      : 'mi-aem-common-spa/components/content/globalnav/utilityNavigation',
    isInEditor: !!props?.isAuthorMode,
    cqPath: cqPath,
  };

  return (
    <Container
      className={clsx('utility-links-wrapper', { 'py-0 ': props?.isAuthorMode })}
      {...UtilityConfig}
      childPages={
        <NavigationUtilityLinkReact
          utilityNavigation={props.utilityNavigation}
          isRenderedInsideOverlay={props.isRenderedInsideOverlay}
          logoUrl={logoUrl}
          logoImageAltText={logoImageAltText}
          logoType={logoType}
          cqPath={cqPath}
          isAuthorMode={!!props?.isAuthorMode}
          isBrandedVariation={props.isBrandedVariation}
          showBonvoyLogo={props.showBonvoyLogo}
          isSimplifiedNavigation={props.isSimplifiedNavigation}
          featureFlagLegacyNav={props.featureFlagLegacyNav}
          isWhiteHeader={props.isWhiteHeader}
          isTransparentHeader={props.isTransparentHeader}
        />
      }
    />
  );
};
